var template = require('../../templates/dashboard/Leave.ejs');
var Chart = require('chart.js');

module.exports = Backbone.View.extend({
    initialize: function({
        $el = null, leaveTypes = null
    }) {
        Backbone.View.prototype.initialize.apply(this, arguments);
        this.$el = $el;
        this.leaveTypes = leaveTypes;

        const annualLeave = this.leaveTypes.find(type => type.get('annual'));

        this.annualExtraCounters = {
            entitled: annualLeave ?
                annualLeave.getDefaultEntitled() : 0,
            carryForward: annualLeave ?
                (annualLeave.getCarriedFoward() || 0)
                    .formatWithoutRounding() : 0,
            remaining: parseFloat(Math.max(0, annualLeave ?
                annualLeave.getEntitled() - annualLeave.getTaken() : 0
            ).formatWithoutRounding())
        };
        this.render();
        return this;
    },

    render: function() {
        const counters = this.leaveTypes.filter(
            type => type.get('annual') || type.getTaken() > 0
        );
        this.$el.html(template({
            leaveTypes: counters,
            annualExtraCounters: this.annualExtraCounters
        }));

        const doughnutOptions = {
            segmentShowStroke: true,
            segmentStrokeColor: '#fff',
            segmentStrokeWidth: 5,
            percentageInnerCutout: 50,
            animation: false,
            tooltipTemplate: '<%- value %> <% if (value === 1) { %>day<% }' +
                ' else { %>days<%}%> <%-label%>',
            customTooltips: tooltip => {
                if (!tooltip) {
                    this.$('.tooltip').remove();
                    return;
                }

                var $tooltip = $('<div>')
                    .addClass('tooltip tooltip-chart fade top in')
                    .append('<div class="tooltip-arrow"></div>');
                var $inner = $('<div>').addClass('tooltip-inner')
                    .html(tooltip.text);
                $tooltip.append($inner);
                $tooltip.css({
                    left: tooltip.chart.canvas.offsetLeft + tooltip.x + 'px',
                    top: tooltip.chart.canvas.offsetTop + tooltip.y + 'px'
                });
                this.$('.js-chart').after($tooltip);
            }
        };

        var ctx = this.$('.js-chart')[0].getContext('2d');
        this.chart = new Chart(ctx).Doughnut(
            this.getDoughnutData(this.leaveTypes),
            doughnutOptions
        );
        return this;
    },

    getDoughnutData: function(leaveTypes) {
        let doughnutData = [];
        leaveTypes
            .filter(type => type.getTaken() > 0)
            .forEach((type) => {
                if (!type) {
                    return;
                }

                doughnutData.push({
                    value: type.getTaken(),
                    label: type.get('name'),
                    color: type.get('color') || '#CCC'
                });
            });

        return doughnutData;
    }
});



// WEBPACK FOOTER //
// ./app/employee/views/dashboard/Leave.js